// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ResourceTier,
} from "./types";

export default {
  imageId: __t.u32(),
  serviceId: __t.u32(),
  get resourceTier() {
    return ResourceTier;
  },
  minReplicas: __t.u8(),
  maxReplicas: __t.u8(),
  extraEnvJson: __t.option(__t.string()),
};
